import {getTestProps} from '@benchling/js-test-utils';
import {css} from 'aphrodite';
import React from 'react';

import {agentProgressStyles} from './ChatProgress';

export interface ProgressFailedProps {
  title: string;
  errorMessage: string;
  testComponent: string;
}

/**
 * Shared failed state component for agent progress.
 * Used by both deep research and data capture when an error occurs.
 */
export function ProgressFailed({title, errorMessage, testComponent}: ProgressFailedProps): JSX.Element {
  return (
    <div
      className={css(agentProgressStyles.failedContainer)}
      {...getTestProps({
        component: testComponent,
        element: 'root',
      })}
    >
      <div className={css(agentProgressStyles.progressHeader)}>
        <span>{title}</span>
      </div>
      <div
        className={css(agentProgressStyles.activityContent)}
        {...getTestProps({
          component: testComponent,
          element: 'content',
        })}
      >
        <span className={css(agentProgressStyles.errorMessage)}>{errorMessage}</span>
      </div>
    </div>
  );
}
